import { render, staticRenderFns } from "./leifeng-shoplist.vue?vue&type=template&id=42a34df5&scoped=true&"
import script from "./leifeng-shoplist.vue?vue&type=script&lang=js&"
export * from "./leifeng-shoplist.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-shoplist.vue?vue&type=style&index=0&id=42a34df5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a34df5",
  null
  
)

export default component.exports